import { marked } from 'marked';

export const renderMarkdown = (content = '') => marked.parse(content || '', { breaks: true });
